/** Parses a TextureProgressBar: the Control and Range bases plus its own members. */
import { parseOptionalBool, parseOptionalFloat, parseOptionalInt, parseOptionalVector2, } from '../../../../parser/valueParsers';
import { parseColorOrUndefined } from '../../../../utils/colorParser';
import { parseControl } from '../control/parser';
import { parseRange } from '../shared/range';
export function parseTextureProgressBar(heading, properties) {
    return {
        ...parseControl(heading, properties),
        // TextureProgressBar's constructor sets `step = 1.0` (measured with
        // `ClassDB.class_get_property_default_value`, 4.6.3). `_calc_value` snaps
        // `value` to it, so an omitted key still snaps.
        ...parseRange(properties, { step: 1 }),
        fillMode: parseOptionalInt(properties.fill_mode),
        ninePatchStretch: parseOptionalBool(properties.nine_patch_stretch),
        radialCenterOffset: parseOptionalVector2(properties.radial_center_offset),
        radialFillDegrees: parseOptionalFloat(properties.radial_fill_degrees),
        radialInitialAngle: parseOptionalFloat(properties.radial_initial_angle),
        stretchMarginBottom: parseOptionalInt(properties.stretch_margin_bottom),
        stretchMarginLeft: parseOptionalInt(properties.stretch_margin_left),
        stretchMarginRight: parseOptionalInt(properties.stretch_margin_right),
        stretchMarginTop: parseOptionalInt(properties.stretch_margin_top),
        textureOver: properties.texture_over,
        textureProgress: properties.texture_progress,
        textureProgressOffset: parseOptionalVector2(properties.texture_progress_offset),
        textureUnder: properties.texture_under,
        tintOver: parseColorOrUndefined(properties.tint_over),
        tintProgress: parseColorOrUndefined(properties.tint_progress),
        tintUnder: parseColorOrUndefined(properties.tint_under),
    };
}
//# sourceMappingURL=parser.js.map